import get from 'lodash/get';
import produce from 'immer';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import AddNewIvrModal from 'src/presentation/components/pages/ivr/components/NewIvrModal';
import analytics from '@ad-scripts/lib/analytics';
import { Button } from 'src/presentation/components/agent_desktop_components';
import ivrsResource from 'src/actions/ivrs/ivrsResource';
import useRouter from 'src/presentation/hooks/useRouter';

function useOnSave({ closeModal }) {
  const dispatch = useDispatch();
  const { history } = useRouter();
  const { createNewIvr, validate } = ivrsResource.effects;
  const { resetErrors } = ivrsResource.actions as any;

  const saveHandler = async ({ workingState }) => {
    dispatch(resetErrors());
    const stateForValidation = produce(workingState, draft => {
      draft.name = get(draft, 'name', '').trim().toLowerCase();
    });

    const isValid = !!dispatch(validate(stateForValidation));

    if (isValid) {
      const { id } = workingState;
      await dispatch(
        createNewIvr(workingState, {
          customToastMsg: null,
          disableWindowBack: true,
        })
      );
      closeModal && closeModal();
      history.push(`/ivrs/${id}`);
    }
  };

  return saveHandler;
}

const useCreateNewIvr = ({ errors }) => {
  const createNewIvrButton = (
    <Button
      data-aid="create-new-ivr-button"
      type={Button.Types.PRIMARY}
      onClick={() => {
        analytics.track('Admin - Create new Ivr');
        openCreateNewIvrModal();
      }}
    >
      Create New IVR
    </Button>
  );

  const [isVisibleCreateNewIvrModal, setIsVisibleCreateNewIvrModal] = useState<boolean>();
  const openCreateNewIvrModal = function () {
    setIsVisibleCreateNewIvrModal(true);
  };
  const closeCreateNewIvrModal = function () {
    setIsVisibleCreateNewIvrModal(false);
  };

  const saveHandler = useOnSave({ closeModal: closeCreateNewIvrModal });

  const newIvrModal = isVisibleCreateNewIvrModal ? (
    <AddNewIvrModal errors={errors} onCancel={closeCreateNewIvrModal} onSubmit={saveHandler} />
  ) : null;

  return { createNewIvrButton, newIvrModal };
};

export default useCreateNewIvr;
